import { makeObservable, action, runInAction } from 'mobx';
import makeQuery from '../../../api/makeQuery';
import mergeMobxListsBy from '../../../util/mergeMobxListsBy';
import Post from '../Post';
import GlobalEvents from '../../../singletons/GlobalEvents';

const postSorter = (a, b) => new Date(b.createdAt) - new Date(a.createdAt);

class PostCollection {
  list = [];
  map = new Map();
  currentPage = 0;
  apiPostCount = null;

  constructor(user) {
    makeObservable(this, {
      list: true,
      map: true,
      length: true,
      currentPage: true,
      apiPostCount: true,
      mergePosts: action,
      removeById: action,
      fetchMore: action,
      refetch: action,
    });
    this.user = user;
  }

  async refetch() {
    console.log('refetch in PostCollection');
    const params = {
      params: {
        limit: this.list?.length || 10,
        page: 0,
        sort: {
          createdAt: -1
        }
      }
    };
    const res = await makeQuery('@getPosts', params);
    console.log({ res, params });
    runInAction(() => {
      this.currentPage = 0;
      this.apiPostCount = res?.meta?.results ?? 0;
      this.mergePosts(res?.paginated);
    });
  }

  async fetchMore() {
    console.log('fetchMore in PostCollection', this);
    if (this.length < this.apiPostCount) {
      const params = {
        params: {
          limit: 10,
          page: this.currentPage + 1,
          sort: {
            createdAt: -1
          }
        }
      };
      const res = await makeQuery('@getPosts', params);
      runInAction(() => {
        console.log({ res });
        this.apiPostCount = res?.meta?.results ?? 0;
        this.currentPage += 1
        this.mergePosts(res?.paginated);
      })
    } else {
      console.log('all posts have already been fetched', {
        fetched: this.length,
        postCount: this.apiPostCount
      });
    }
  }

  mergePosts(posts) {
    mergeMobxListsBy(
      this.map,
      this.list,
      posts,
      'id',
      (v) => new Post(v),
      false,
    );
  }

  removeById(id) {
    if (this.map.delete(id)) {
      const idx = this.list.findIndex(
        (a) => a.id === id,
      );
      if (idx !== -1) {
        this.list[idx].destroy();
        this.list.splice(idx, 1);
      }
    }
  }

  async addPost({date, location, logs}) {
    try {
      const post = { date, location, logs };
      const response = await makeQuery('@postPost', { post });
      this.mergePosts([response]);
      return true;
    } catch (e) {
      if (e === -1) {
        GlobalEvents.emit('addPost', {
          status: 'error',
          name: 'Error adding post'
        });
      } else throw e;
    }
  }

  destroy() {
    for (const post of this.list) {
      post.destroy();
    }
  }

  getById(id) {
    return this.map.get(id);
  }

  get length() {
    return this.list.length;
  }

  get posts() {
    return this.list.slice().sort(postSorter);
  }

  get hasMoreResults() {
    return this.length < this.apiPostCount;
  }
}

export default PostCollection;
